import { render, staticRenderFns } from "./OrderIndex.vue?vue&type=template&id=3a07720e&scoped=true"
import script from "./OrderIndex.vue?vue&type=script&lang=js"
export * from "./OrderIndex.vue?vue&type=script&lang=js"
import style0 from "./OrderIndex.vue?vue&type=style&index=0&id=3a07720e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a07720e",
  null
  
)

export default component.exports